import { loadingState } from "@/state/loading";
import { useRecoilState } from "recoil";

// for backward compatibility
export const useGlobalLoaderService = () => {
  const [loading, setGlobalLoading] = useRecoilState(loadingState);
  return { loading, setGlobalLoading };
};
